import { render, staticRenderFns } from "./mainNavbar.vue?vue&type=template&id=047383ce&scoped=true"
import script from "./mainNavbar.vue?vue&type=script&lang=js"
export * from "./mainNavbar.vue?vue&type=script&lang=js"
import style0 from "./mainNavbar.vue?vue&type=style&index=0&id=047383ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047383ce",
  null
  
)

export default component.exports